module.exports = __webpack_public_path__ + "static/media/strengthlogonew.52d43d51.png";